import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { SharedService } from 'src/app/services/sharedService';
import { InformationDialogComponent } from '../../dialogs/information-dialog/information-dialog.component';
import { MapService } from '../../map/map.service';

@Component({
  selector: 'app-building-editor',
  templateUrl: './building-editor.component.html',
  styleUrls: ['./building-editor.component.css']
})
export class BuildingEditorComponent implements OnInit {

  municipalityChangeSubscription: any
  buildingId
  selectedBuildingDetails
  bbox
  locationLatLng
  boundaries
  selectedFilter
  propForm
  ccData = {}
  propertyTax
  loadBuildings = false
  layers
  childLayer = {}

  constructor(public sharedService: SharedService,
    public dialog: MatDialog,
    public mapService: MapService,
    private activatedRoute: ActivatedRoute,
    private propertyTaxService: PropertyTaxService) {
  }

  chDropdown(ev) {
    if (ev?.field === 'ILOT') {
      this.loadBuildings = true
    } else if (['DISTRICT', 'MUNICIPALITY'].includes(ev?.field)) {
      this.loadBuildings = false
    }
    this.selectedFilter = ev
    if (this.selectedFilter.coordinates) {
      this.boundaries = this.selectedFilter.coordinates
    }
    else this.boundaries = null
    this.bbox = this.boundaries?.bbox
  }



  async ngOnInit() {
    this.layers = this.sharedService.getAllLayers()
    this.propForm = await this.propertyTaxService.getForm('propTaxForm').toPromise()
    this.ccData = {
      key: this.propForm.key,
      name: this.propForm.name,
      stages: [this.propForm]
    }
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      this.bbox = val && val['bbox'] || undefined
      if (this.bbox !== undefined) {
        localStorage.setItem('municipalityBbox', this.bbox)
      }
    })
  }

  selectBuilding(ev) {
    this.selectedBuildingDetails = ev
  }

  setBBox(val) {
    if (localStorage.getItem('municipalityBbox'))
      this.bbox = localStorage.getItem('municipalityBbox')

    let queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams.buildingId) {
      setTimeout(async () => {
        this.buildingId = queryParams.buildingId
        this.loadBuildings = true
       // this.propertyTax = await this.propertyTaxService.getPropertyTaxByBuildingId(this.buildingId).toPromise()
      }, 0)
    } else {
      this.loadBuildings = false
    }
  }
  setBoundaries(boundaries) {
    this.boundaries = boundaries
  }
  openForm() {
    this.sharedService.openPropertyTaxForm('BUILDING')
  }

  async saveForm(form) {
    const mapMunicipality = this.getMapAttribute('municipality');
    const mapDistrict = this.getMapAttribute('district');
    const mapIlot = this.getMapAttribute('ilot');

    let municipality = this.normalizeLocationObject(form.municipality, mapMunicipality);
    let district = this.normalizeLocationObject(form.district, mapDistrict);
    let ilot = this.normalizeLocationObject(form.ilot, mapIlot);
  
    try {
  
      const buildingArea =
        form.building?.area ||
        form.building?.attributes?.area ||
        this.selectedBuildingDetails?.area ||
        this.selectedBuildingDetails?.attributes?.area ||
        0;

      const building = {
        ...form.building,
        attributes: {
          ...(form.building?.attributes || {}),
          area: buildingArea
        }
      };

      const payload: any = {
        id: form.id,
        municipality,
        district,
        ilot,
        lot: form.lot,
        building,
        attributes: form.form
      };
  
      if (form.taxPayer) {
        payload.taxPayer = form.taxPayer;
      }
      let prT = await this.propertyTaxService.setPropertyTax(payload).toPromise()
      this.sharedService.uploadPropertyTaxFormAttachments(prT.id)
      if (form.declare) {
        const declarePayload: any = {
          declarationType: 'BUILDING',
          taxPayer: form.taxPayer,
          buildingId: form.building?.id,
          form: form.form,
          year: new Date().getFullYear().toString(),
          month: new Date().getMonth() + 1
        };
    
        await this.propertyTaxService.declarePropertyTax(declarePayload).toPromise();
      }
      this.sharedService.closePropertyTaxForm()
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: form.declare ? "DIALOG.PROP_TAX_DECLARED" : "DIALOG.PROP_TAX_SAVED" },
      });
    } catch (error) {
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.PROP_TAX_SAVE_ERROR" },
      });
    }
  }

  getMapAttribute(attrName) {
    return this.selectedBuildingDetails
      && this.selectedBuildingDetails.attributes
      && this.selectedBuildingDetails.attributes[attrName]
      ? this.selectedBuildingDetails.attributes[attrName]
      : null;
  }
  
  normalizeLocationObject(formValue, mapValue) {
    const source = formValue || mapValue || {};
  
    return {
      id: source.id,
      name: source.name || source.key
    };
  }

  getChildLayer(layer) {
    switch (layer) {
      case 'municipality':
        return { layer: this.sharedService.getLayer('district'), parentId: this.selectedFilter.value.id }
      case 'district':
        return { layer: this.sharedService.getLayer('ilot'), parentId: this.selectedFilter.value.id }
      default:
        return null
    }
  }

}
